import * as Api from '../../../api/Api';
import { useState } from 'react';
import PermissionsGate from '../../../api/PermissionsGate';
import { SCOPES } from '../../../config/permissions-map';
import { Unauthorized } from '../../Global/unauthorized';
import { useGetToken } from '../../../Hooks/CustomHooks';
import * as Utilities from '../../../Components/Utils/Utils';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { PageTitle } from '../../../../_metronic/layout/core';
import { registerLocale } from 'react-datepicker';
import es from "date-fns/locale/es";
import "react-datepicker/dist/react-datepicker.css";
import AgTable from '../../../Components/Table/AgTable';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';

export default function VentasM2Locatario({ title }) {
    const currentDate = new Date()
    const [dateRange, setDateRange] = useState([new Date(1, currentDate.getMonth(), currentDate.getFullYear()), new Date()]);
    registerLocale("es", es);

    const [value, onChange] = useState([new Date(currentDate.getFullYear(), currentDate.getMonth(), 1), new Date()]);


    let header = [
        {
            headerName: 'Contrato',
            field: 'contrato',
            type: 'rightAligned',
        },
        {
            headerName: 'Nombre de Fantasía',
            field: 'nombreFantasia',
        },
        {
            headerName: 'Objetos',
            field: 'objetos',
        },
        {
            headerComponent: () => (<span>Area (m<sup>2</sup>)</span>),
            field: 'area',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.area, true, 4)}</>
            )
        },
        {
            headerName: 'Cod-Rubro',
            field: 'codRubro',
        },
        {
            headerName: 'Rubro',
            field: 'rubro',
        },
        {
            headerName: 'Cod-Cebe',
            field: 'codCebe',
        },
        {
            headerName: 'CEBE',
            field: 'cebe',
        },
        {
            headerName: 'Comercial',
            field: 'comercial',
        },
        {
            headerComponent: () => (<span>Total (m<sup>2</sup>)</span>),
            field: 'totalm2',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.totalm2, true)}</>
            )
        }

    ];

    const animatedComponents = makeAnimated();
    const [unidadEconomica, setUnidadEconomica] = useState(Utilities.getListUnidadesEconomicas().list[0]);
    let unidadesEconomicasList = Utilities.getListUnidadesEconomicas();


    const getOptionValue = idDefault => {
        return unidadesEconomicasList.list.filter(obj => obj.value === idDefault)
    }
    const onChangeGraphType = (inputValue) => {
        setUnidadEconomica(inputValue);
    }

    return (
        <>
            <PermissionsGate RenderError={() => <Unauthorized />} scopes={[SCOPES.VENTAS_LOCATARIOS_M2]} >
                <PageTitle>{title}</PageTitle>

                <div className="card my-5">
                    <div className="card-header border-0 pt-6 row g-3 flex-wrap d-flex flex-row">
                        <div className='col-12 col-sm-6'>
                            <div className="fw-bold fs-7 text-gray-600 mb-1">Rango de Fecha:</div>
                            <DateRangePicker
                                onChange={(dateRange) => {
                                    onChange(dateRange)
                                    dateRange &&
                                        setDateRange(dateRange);
                                }}
                                value={value}
                                format="dd/MM/y"
                                className="form-control form-control-transparent fit-content-width"
                                locale="es"
                            />
                        </div>

                        <div className="col-12 col-sm-4">
                            <div className="fw-bold fs-7 text-gray-600 mb-1">Mall:</div>
                            <Select
                                classNamePrefix='filter'
                                components={animatedComponents}
                                defaultValue={getOptionValue(unidadesEconomicasList.defaultId)}
                                isMulti={false}
                                closeMenuOnSelect={true}
                                options={unidadesEconomicasList.list}
                                onChange={(onChangeGraphType)}
                            />
                        </div>
                    </div>

                    <div className="card-body tab-content pt-0">
                        <AgTable
                            idContent={"Reporte de Ventas Por Metro Cuadrado Por Locatario " + unidadEconomica.value + (dateRange[0] != null ? Utilities.formaterDate(dateRange[0]) : "") + (dateRange[1] != null ? Utilities.formaterDate(dateRange[1]) : "")}
                            apiService={Api.VentasM2Locatario}
                            setAuxData={null}
                            header={header}
                            titleExcel={"Reporte de Ventas Por Metro Cuadrado Por Locatario " + unidadEconomica.label + " " + (dateRange[0] != null ? Utilities.formaterDate(dateRange[0]) : "") + " / " + (dateRange[1] != null ? Utilities.formaterDate(dateRange[1]) : "")}
                            conditions={dateRange[0] != null && dateRange[1] != null}
                            args={{ fechaInicio: dateRange[0] && Utilities.formaterDate(dateRange[0]), fechaFin: dateRange[1] && Utilities.formaterDate(dateRange[1]), unidadEconomicaId: unidadEconomica.value, token: useGetToken() }}
                            hideFilter={false}
                            paginationPageSize={8}
                            rowHeight={40}
                            useFlex={false}
                        />
                    </div>
                </div>
            </PermissionsGate>
        </>
    )
}